function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 7.736C3 7.329 3.374 7 3.835 7h8.33c.461 0 .835.328.835.736v5.528c0 .407-.374.736-.835.736h-8.33C3.374 14 3 13.672 3 13.264V7.736z",
  fill: "#A0AFBE"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 7V5c0-1.5.5-2.5 2-2.5h2c1.5 0 2 1 2 2.5v2",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgSecure;